import $ from 'jquery';

export const PXResources = (function () {
	'use strict';

	let $resources = $('.resources__column'),
		$select = $('.resources__filters select');

	function init() {
		events();
	}

	function events() {
		console.log('resources js firing');

		$select.on('change', (ev) => {
			let activeClass = '';

			$select.each(function () {
				if ($(this).val()) {
					activeClass += '.' + $(this).val();
				}
			});

			console.log(ev, $select);

			$resources.addClass('hidden');
			$('.resources__column' + activeClass).removeClass('hidden');
		});
	}

	return {
		init: init,
	};
})();
